import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ProfileForm from './ProfileForm';
import NotificationsPanel from './NotificationsPanel';
import './Profile.css';

class ProfilePage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            user,
            cities,
            notifiedCityIds,
            canCustomizeNotifications,
            csrfToken,
            routes,
        } = this.props;

        return (
            <div className="profile-page-container">
                <ProfileForm
                    user={user}
                    csrfToken={csrfToken}
                    routes={routes}
                />

                {canCustomizeNotifications && (
                    <NotificationsPanel
                        cities={cities}
                        notifiedCityIds={notifiedCityIds}
                        csrfToken={csrfToken}
                        routes={routes}
                    />
                )}
            </div>
        );
    }
}

export default ProfilePage;

const rootElement = document.getElementById('profile-page-root');
if (rootElement) {
    const props = JSON.parse(rootElement.getAttribute('data-props') || '{}');
    ReactDOM.render(<ProfilePage {...props} />, rootElement);
}
